export default {
	"server_host":"https://saue.snapquick.app/",
	"app_data":"app-datos/app-saue.json"
 }